export default {
    loadEventSpeakers: function (eventId, speakers) {
        return {
            type: 'EVENT_SPEAKERS_LOADED',
            eventId,
            speakers
        };
    },
};
